import { NgClass, NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Observable } from 'rxjs';

import { ScrollContainerComponent } from '../../common/components/scroll.container/scroll.container.component';
import { FilterMultiComponent, FilterObject } from '../../common/filter';
import {
  ListOption,
  ScrollableListComponentBase,
} from '../../common/list.component.base';
import { DELETED, WebUtils } from '../../common/utils';
import { AccessUtils, TEvent, TLocation, TOrganization } from '../../core/entities';
import { SiteFormatMixin } from '../../thinkdesks/site.format.mixin';
import { TLocationBase, TSpaceBase } from '../../thinkdesks/thinkdesks.entities';
import { EventEditDialogComponent } from './event.edit.dialog';

class _Base extends ScrollableListComponentBase<TEvent> {}

@Component({
  selector: 'app-event-list',
  templateUrl: './event.list.component.html',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    FilterMultiComponent,
    ScrollContainerComponent,
    FontAwesomeModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatDialogModule,
    MatToolbarModule,
  ],
})
export class EventListComponent extends SiteFormatMixin(_Base) {
  _common = _common;
  @HostBinding('class') css = 'max-height';

  filterObject = new FilterObject();
  //   status = new FilterMulti();

  //   type = new FilterMulti();

  displayedColumns: string[] = ['name', 'location', 'space', 'date', 'controls'];

  @Input()
  space: TSpaceBase;

  @Input()
  location: TLocationBase;

  @Input()
  organization: TOrganization;

  constructor(
    override http: HttpClient,
    override elRef: ElementRef,
    private dialog: MatDialog,
    override snackBar: MatSnackBar
  ) {
    super(http, snackBar, elRef);
    // this.pageSort = 'seq';
    // this.pageSortDir = 'asc';
  }

  override createRequest(options: ListOption): Observable<Object> {
    let query = {
      space: WebUtils.objId(this.space),
      location: WebUtils.objId(this.location),
    } as any;
    Object.assign(query, this.filterObject.query());

    const url = this._listModifyUrl(`/api/event/list`, {}, options);
    return this.http.post(url, query);
  }
  override ngOnInit() {
    super.ngOnInit();
    // this.filterObject.add('type', this.type);
    // this.filterObject.add('status', this.status);
  }
  override listFixList(list: TEvent[]) {
    for (let o of list) AccessUtils.fixEvent(o);
  }

  add() {
    const ref = this.dialog.open(EventEditDialogComponent, {
      data: {
        organization: this.organization,
        location: this.location,
        space: this.space,
      },
    });
    ref.afterClosed().subscribe((result) => {
      if (result) {
        this._addToList(result);
      }
    });
  }

  override selectObject(o: TEvent) {
    var location = o.space?.location as TLocation;
    const dialogRef = this.dialog.open(EventEditDialogComponent, {
      data: {
        objectId: o.id,
        organization: this.organization ?? location?.organization,
        location: this.location ?? location,
        space: this.space ?? o.space,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == DELETED) {
        this._removeFromList(o);
      } else if (result) {
        Object.assign(o, result);
      }
    });
  }
}
